<script setup lang="ts">
import { useModalStore } from "../../../store/modal";
import { useTicketStore } from "../../../store/tickets";
import DefaultModalBase from "../DefaultModalBase.vue";
import {computed, ref} from "vue";

const ticketStore = useTicketStore()
const modalStore = useModalStore()
const loading = ref(false)
const note_added = ref(false)
const failed = ref(false)
const disabled = computed(() => loading.value || !note.value)
const heading = computed(() => {
    if (note_added.value) {
        return "Note added."
    }

    return failed.value ? "Couldn't add the note, try again." : "Add a note."
})
const note = ref()
const addNote = async () => {
    loading.value = true
    failed.value = false

    try {
        await ticketStore.addNote(modalStore.props.id, note.value)
        note_added.value = true
    } catch {
        failed.value = true
    } finally {
        loading.value = false
    }
}
</script>

<template>
<DefaultModalBase :heading :icon="note_added ? 'check-all' : 'paper-file'" :loading>
    <div class="call-assign-container" >
        <brand-form-textarea label="Note details." v-model="note" v-if="!note_added"/>
        <brand-button @click="addNote()" :disabled v-if="!note_added">Save note</brand-button>
        <brand-button @click="modalStore.close()" variant="secondary" v-else>Done</brand-button>
    </div>
</DefaultModalBase>
</template>

<style scoped lang="scss">
.call-assign-container {
    display: flex;
    flex-direction: column;
    gap: 3rem;
}
</style>
